import { MapArtifactToSlides } from 'interfaces/jobs/basic';

export interface FixedStainParams {
  stainVectors: { [key: string]: number[] };
  maxBrightness?: number[][];
}

export interface CellCompartmentParams {
  membraneOutwardsThicknessUm?: number;
  membraneInwardsThicknessUm?: number;
}

export interface CellQuantificationJobConfig {
  inputArtifactUrlPatterns: MapArtifactToSlides[];
  quantifiedChannelNames: string[];
  syntheticSegmentationConfigurationDefaultCase?: number;
  cellCompartmentParams?: CellCompartmentParams;
  syntheticCytoplasmThicknessUm?: number;
  syntheticNuclearRadiusUm?: number;
  syntheticMembraneErosionFactor?: number;
  fixedStainParams?: FixedStainParams;
  manifest: string[];
}

export interface QuantificationFormValues {
  jobName: string;
  jobDescription: string;
  configParams: CellQuantificationJobConfig;
}

export enum RunQuantificationStep {
  LoadParams = 'Reuse Previous Job Settings',
  NameAndDescription = 'Name and Description',
  SelectInferenceModels = 'Select Inference Models',
  AdditionalParameters = 'Additional Parameters',
  SyntheticSegmentationConfiguration = 'Synthetic Segmentation Configuration',
}

export const runQuantificationOrder = [
  RunQuantificationStep.LoadParams,
  RunQuantificationStep.NameAndDescription,
  RunQuantificationStep.SelectInferenceModels,
  RunQuantificationStep.AdditionalParameters,
  RunQuantificationStep.SyntheticSegmentationConfiguration,
];
